import type { PipelineNodeKindSpec } from '@elmes/plugin-sdk';

const ACTION = {
  category: 'action',
  color: 'text-blue-700 dark:text-blue-300',
  bgColor: 'bg-blue-50 dark:bg-blue-900/30',
  borderColor: 'border-blue-300 dark:border-blue-700',
  hasInput: true,
  hasOutput: true,
} as const;

/** Editor metadata of the api's `pipelineNodes` (stock, then sales): core's NODE_META entries until W4-K5b. */
export const elmesPipelineNodeKinds: Readonly<Record<string, PipelineNodeKindSpec>> = {
  stockReceive: { ...ACTION, icon: 'PackagePlus', label: 'Stok Girişi' },
  stockIssue: { ...ACTION, icon: 'PackageMinus', label: 'Stok Çıkışı' },
  stockTransfer: { ...ACTION, icon: 'Truck', label: 'Stok Transferi' },
  stockAdjust: { ...ACTION, icon: 'SlidersHorizontal', label: 'Stok Düzeltme' },
  stockLevels: { ...ACTION, icon: 'Boxes', label: 'Stok Seviyeleri' },
  stockMovements: { ...ACTION, icon: 'ScrollText', label: 'Stok Hareketleri' },
  pricingResolve: { ...ACTION, icon: 'Tag', label: 'Fiyat Çöz' },
  quoteConvert: { ...ACTION, icon: 'FileText', label: 'Teklifi Siparişe Çevir' },
  salesOrderConfirm: { ...ACTION, icon: 'ClipboardCheck', label: 'Siparişi Onayla' },
  salesOrderFulfil: { ...ACTION, icon: 'PackageCheck', label: 'Siparişi Karşıla' },
  stockReservations: { ...ACTION, icon: 'Bookmark', label: 'Stok Rezervasyonları' },
};
